import { DriverStatus, QualityBonus } from './model/quality-bonus-model';

export const PREMIUM_LEVEL_TO_DRIVER_STATUS: Record<number, DriverStatus> = {
  0: DriverStatus.NONE,
  1: DriverStatus.BRONZE,
  2: DriverStatus.SILVER,
  3: DriverStatus.GOLD,
};

export const QUALITY_BONUS_CLASSES = {
  [QualityBonus.GOLD]: 'status-gold',
  [QualityBonus.SILVER]: 'status-silver',
  [QualityBonus.BRONZE]: 'status-bronze',
};

export const QUALITY_BONUS_TRANSLATIONS = {
  [QualityBonus.GOLD]: 'movacarpro_quality_bonus_gold',
  [QualityBonus.SILVER]: 'movacarpro_quality_bonus_silver',
  [QualityBonus.BRONZE]: 'movacarpro_quality_bonus_bronze',
};

export const PREMIUM_LEVEL_TO_QUALITY_BONUS: Record<
  number,
  QualityBonus | null
> = {
  0: null,
  1: QualityBonus.BRONZE,
  2: QualityBonus.SILVER,
  3: QualityBonus.GOLD,
};
